<script>
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon,
} from "vue-feather-icons";
export default {
  data() {
    return {};
  },
  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    MailIcon,
  },
};
</script>

<template>
  <div>
    <!-- Footer Start -->
    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
            <a href="#" class="logo-footer">
              <img src="images/quarantine_white.png" height="50" alt="" />
            </a>
            <p class="mt-4">
              Book your quarantine bookings with us at Quarantine Facility.
            </p>
          </div>
          <!--end col-->
          <!--end col-->

          <div class="col-lg-6 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h5 class="text-light footer-head">Contact Us</h5>
            <ul class="list-unstyled footer-list mt-4">
              <li>
                <span class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i
                  ><a href="mailto:hello@quarantinefacility.ph">hello@quarantinefacility.ph</a></span
                >
                <br />
                <span class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i>GLOBE:
                  <a href="tel:+639610115478">+63961-011-5478</a></span
                >
                <br />
                <span class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i>SMART:
                  <a href="tel:+639568703665">+63956-870-3665</a></span
                >
              </li>
            </ul>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </footer>
    <!--end footer-->
    <!--end footer-->
  </div>
</template>
